import styled from 'styled-components';
import COLORS from '../../../../common/styles/color-pallete';
import devices from '../../../../common/styles/devices';
import { FONT_FAMILY } from '../../../../common/styles/fontStyles';
export const SGDocsContainer = styled.div`
  border-radius: 8px;
  border: solid 1px #eaeaea;
  background-color: #ffffff;
  max-width: 500px;
  align-self: center;
  justify-self: center;
  width: 100%;
  padding: 6% 7%;
  @media (min-width: 768px) and (max-width: 1023px) {
    border-radius: 8px;
    border: solid 1px #eaeaea;
    background-color: #ffffff;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    align-self: center;
    justify-self: center;
    width: 100%;
    padding: 6% 7%;
  }
  @media (min-width: 1024px) {
    border-radius: 8px;
    border: solid 1px #eaeaea;
    background-color: #ffffff;
    max-width: 500px;
    align-self: center;
    justify-self: center;
    width: 100%;
    padding-top: 20px;
    padding-left: 70px;
    padding-right: 70px;
    padding-bottom: 20px;
  }
  @media ${devices.mobileL} {
    width: 100%;
    display: block;
    border: none;
    min-width: 325px;
  }
  @media ${devices.mobileM} {
    width: 100%;
    display: block;
    border: none;
    min-width: 325px;
  }
  @media ${devices.mobileS} {
    width: 100%;
    display: block;
    border: none;
    min-width: 300px;
  }
`;

export const BackCont = styled.div`
  margin-right: auto;
`;
export const DocsFlexContainer = styled.div`
  @media (min-width: 1024px) {
    width: 100%;
    display: grid;
    grid-template-columns: 50px 1fr;
    padding-left: 50px;
    justify-content: center;
    align-self: center;
    padding: 0;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  @media ${devices.mobileL} {
    width: 100%;
    display: block;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media ${devices.mobileM} {
    width: 100%;
    display: block;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media ${devices.mobileS} {
    width: 100%;
    display: block;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Header = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 36px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  margin-bottom: 30px;
  @media ${devices.tablet} {
    font-size: 34px;
    text-align: left;
  }
  @media ${devices.mobileL} {
    font-size: 34px;
    text-align: left;
  }
  @media ${devices.mobileM} {
    font-size: 30px;
    text-align: center;
  }
  @media ${devices.mobileS} {
    font-size: 29px;
    text-align: left;
  }
`;

export const SUCCESS_MSG = styled.div`
  margin-top: 15px;
  color: #4CAF50;
  font-size: 12px;
}`;

export const NOTES = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: ${COLORS.textLightGrey};
  padding-top: 25px;
`;
